// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressBar_wrapper__hLZEJ","alive":"ProgressBar_alive__Vprou","text":"ProgressBar_text__JGhS7"};